import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { logout } from "../../stores/user";
import { useDocumentTitle } from "$utils/document-title";

const logoutAction = async (instance) => {
    await logout();
    await instance.logoutRedirect({
        postLogoutRedirectUri: "/",
        mainWindowRedirectUri: "/",
    });
};
let hasLoaded = false;

/**
 * @description This component runs after receiving a successful logout from azure
 *
 **/
const Logout = () => {
    useDocumentTitle("Logout");
    const { instance } = useMsal();
    useEffect(() => {
        if (!hasLoaded) {
            hasLoaded = true; // Making sure this only gets called once
            (async () => {
                await logoutAction(instance);
            })();
        }
    }, [instance]);
    return null;
};

export default Logout;
